import React, { useMemo } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useMaxZ } from 'ui-components/hooks/services/use-max-z';

import { ChildrenPropType } from '../../prop-types/children';

import style from './drawer.module.less';

const Drawer = ({ className, onClose, children }) => {
  const zIndex = useMaxZ();
  const zIndexStyle = useMemo(() => ({ zIndex }), [zIndex]);

  return (
    <div className={style['drawer-container']} style={zIndexStyle}>
      <div className={style['drawer-background']} onClick={onClose} />
      <div className={classnames(style.drawer, className)}>{children}</div>
    </div>
  );
};

export { Drawer };

Drawer.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  children: ChildrenPropType.isRequired,
};
